// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3AK-h","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3u5KS","obliqueLine":"membershipbadge_obliqueLine__3GOd2"};